import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { aboutViewStyles } from './about-view.css';
import { renderAboutViewPresentation } from './about-view-presentation';

@customElement('about-view')
export class AboutView extends LitElement {
  static styles = [aboutViewStyles];

  render() {
    return renderAboutViewPresentation();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'about-view': AboutView;
  }
}
